'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { buyerBenefits, tradeBenefits } from './buyerAssuranceMessage.es';

import BuyerAssuranceIcon from 'dibs-vg/dist/react/buyer-assurance';
import styles from './BuyerAssuranceBox-style.scss';

import { trackEvent } from 'dibs-tracking';

const links = {
    buyer: '/about/promise/',
    trade: '/info/trade/benefits/',
};

const getCopy = isTrade => {
    if (isTrade) {
        return {
            link: links.trade,
            benefits: tradeBenefits,
        };
    }

    return {
        link: links.buyer,
        benefits: buyerBenefits,
    };
};

const Benefit = ({ benefit, isTrade }) => {
    return (
        <div className={styles.benefit}>
            <div className={styles.icon}>
                <BuyerAssuranceIcon className={isTrade ? styles.iconTrade : ''} />
            </div>
            <div className={styles.copy}>
                <FormattedMessage {...benefit} />
            </div>
        </div>
    );
};

Benefit.propTypes = {
    benefit: PropTypes.object,
    isTrade: PropTypes.bool,
};

const BuyerAssuranceBox = ({ isTrade }) => {
    const { link, benefits } = getCopy(isTrade);

    const trackLearnMore = () =>
        trackEvent({
            action: 'banner clicked',
            label: 'Buyer Guarantee - PDP',
            category: 'promo interaction',
            value: 0,
        });

    return (
        <div className="buyer-assurance-box-wrapper">
            <div className="buyer-assurance-box-container">
                <h2 className={styles.title}>
                    <FormattedMessage
                        id="pdp.buyerAssurance.title"
                        defaultMessage={`{isTrade, select,
                            true {Why Designers Shop on 1stdibs}
                            other {Why Shop on 1stdibs?}
                        }`}
                        values={{ isTrade }}
                    />
                </h2>
                <div className={styles.link}>
                    <a href={link} onClick={trackLearnMore}>
                        <FormattedMessage
                            id="pdp.buyerAssurance.learnMore"
                            defaultMessage="Learn More"
                        />
                    </a>
                </div>
                <div className={styles.benefits}>
                    {Object.keys(benefits).map(key => (
                        <Benefit key={benefits[key].id} isTrade={isTrade} benefit={benefits[key]} />
                    ))}
                </div>
            </div>
        </div>
    );
};

BuyerAssuranceBox.propTypes = {
    isTrade: PropTypes.bool,
};

BuyerAssuranceBox.defaultProps = {
    isTrade: false,
};

module.exports = BuyerAssuranceBox;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssuranceBox.jsx